import React from "react";
import { Outlet } from "react-router-dom";
import MailTemplate from "@/pages/mailTemplate";

const MailTemplateRouter = [
  {
    path: "/mailTemplate",
    element: <MailTemplate />,
  },
];

export default MailTemplateRouter;